import React, {useMemo} from 'react'
import {useTranslation} from 'react-i18next'
import {Typography} from '@material-ui/core'
import GasPhaseChart from 'assets/img/gas_phase_image.png'
import SummaryTable from 'components/molcules/ProfitSummaryReport/SummaryTable'
import ReportSubtitle from 'components/Text/ReportSubtitle'
import useLanguage from 'features/languageReport/useLanguage'
import useStyles from 'components/molcules/N1SummaryReport/useStyles'
import {simpleSanitizeHTML} from 'helpers/analysisHelper'

interface HeadCell {
  id: string
  label: string
}

const getGasPhasePosition = (phase: number) => {
  if (phase < 1 || phase > 5) return '-100%'
  if (phase === 1) return '3%'
  if (phase === 2) return '22.75%'
  if (phase === 3) return '42.5%'
  if (phase === 4) return '62.25%'
  if (phase === 5) return '81.3%'
  return '-100%'
}

export default function HRVSummaryStressAPI(props: {phase: number}) {
  const {phase} = props
  const classes = useStyles()
  const {textHrvAPI} = useLanguage('hrv')
  const {i18n} = useTranslation()

  const hrvStressItem: HeadCell[] = useMemo(() => {
    return (
      textHrvAPI?.gas_phase_analysis.section.gas_table.rows.map((item) => ({
        id: item.phase,
        label: item.explanation,
      })) || []
    )
  }, [textHrvAPI])

  return (
    <div className={classes.hrvStress}>
      <Typography className={classes.padding} />
      <Typography className={classes.padding} />
      <ReportSubtitle number='4'>
        {textHrvAPI?.gas_phase_analysis.title}
      </ReportSubtitle>

      <div className='Wrapper'>
        <img className='PhaseChart' src={GasPhaseChart} alt='Gas Phase chart' />
        <div
          className={classes.chartLabelContainer}
          style={{left: getGasPhasePosition(phase)}}
        >
          <span className='PhaseChart-Label-API'>
            {textHrvAPI?.gas_phase_analysis.section.gas_phase.current_state}
          </span>
          <div className={classes.labelArrow} />
        </div>
        {[7, 27, 46, 66, 85].map((left, index) => (
          <div
            key={index}
            className={classes.phaseLabel}
            style={{left: `${left}%`}}
          >
            {textHrvAPI?.gas_phase_analysis.section.gas_table.rows[index].phase}
          </div>
        ))}
      </div>
      <Typography className={classes.padding} />
      <div
        className={classes.description}
        // @ts-ignore
        // eslint-disable-next-line
        dangerouslySetInnerHTML={{
          __html: simpleSanitizeHTML(
            textHrvAPI?.gas_phase_analysis.section.gas_phase.description ?? '',
          ),
        }}
      />
      <Typography className={classes.padding} />
      <SummaryTable
        items={hrvStressItem}
        headerTitle={
          textHrvAPI?.gas_phase_analysis.section.gas_table.headers[0] || ''
        }
        descriptionTitle={
          textHrvAPI?.gas_phase_analysis.section.gas_table.headers[1] || ''
        }
      />
    </div>
  )
}
